"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../../../../../../hooks");
var _CetComponentsProvider = require("../../../../../../../providers/CetComponentsProvider");
const useStyles = () => {
  const {
    themeColors
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    pxToRem
  } = (0, _hooks.useStylesUtils)();
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const ccTaskManagerTaskDateTimePickerStyle = (0, _react.useMemo)(() => {
    const deviceBtnProps = () => {
      const width = isMobileView ? '100%' : 'auto';
      return {
        width
      };
    };
    const ccTaskManagerTaskDateTimePicker = (0, _css.css)({});
    const ccTaskManagerTaskDateTimePickerFrame = (0, _css.css)({
      display: 'flex',
      border: `1px solid ${themeColors?.general.border}`,
      borderRadius: pxToRem(isMobileView ? 6 : 25),
      width: isMobileView ? 'auto' : 'fit-content',
      padding: `0 ${pxToRem(24)}`,
      gap: pxToRem(24),
      '& > div:nth-child(1)': {
        ...deviceBtnProps()
      },
      '& > div:nth-child(3)': {
        ...deviceBtnProps()
      }
    });
    const ccTaskManagerTaskDateTimePickerFrameSpacer = (0, _css.css)({
      width: '1px',
      background: themeColors?.general.border,
      margin: `${pxToRem(1)} 0`
    });
    return {
      ccTaskManagerTaskDateTimePicker,
      ccTaskManagerTaskDateTimePickerFrame,
      ccTaskManagerTaskDateTimePickerFrameSpacer
    };
  }, [isMobileView, pxToRem, themeColors?.general.border]);
  return {
    'cc-TaskManager__task-date-time-picker': ccTaskManagerTaskDateTimePickerStyle.ccTaskManagerTaskDateTimePicker,
    'cc-TaskManager__task-date-time-picker__frame': ccTaskManagerTaskDateTimePickerStyle.ccTaskManagerTaskDateTimePickerFrame,
    'cc-TaskManager__task-date-time-picker__frame-spacer': ccTaskManagerTaskDateTimePickerStyle.ccTaskManagerTaskDateTimePickerFrameSpacer
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;